(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name SolicitudvideoController
* @description
* This is main controller
**/ 

  angular
  .module('app')
  .controller('SolicitudvideoController', SolicitudvideoController);

  SolicitudvideoController.$inject = ["PagosService","GenerallabService","VideoconsultaService","PedidoService","StripeService","Upload","HistorialService","$uibModal","UserService","$timeout","$location"];

  function SolicitudvideoController(PagosService,GenerallabService,VideoconsultaService,PedidoService,StripeService,Upload,HistorialService,$uibModal,UserService,$timeout,$location){

    var vm = this;
      vm.servicio_id = 2528;
      vm.pacientes = {};
      vm.paciente = "";
      vm.pagina = 0 ;
      vm.generalLab = GenerallabService;
      vm.pedido_id = "";
      vm.videoconsulta = { ficheros : [], paciente_id:"", id: "" };
      vm.pago_realizado = false;
      vm.consulta_editada = false;
      vm.times = [];
      vm.stripe = StripeService;
      vm.params = [];
      vm.selected = false;
      vm.videoconsultasList = [];
      vm.videoconsultasCal = [];
      vm.timesFinal = [];
      vm.fechas_saved = [];
      vm.consultas_meses = "";
      vm.days = "";
        vm.errorB = false;
      vm.events = "";
      vm.sexos = "";
      vm.nueva_video_consulta= "";
      vm.sended = true;
      vm.filtros  = { nombre: "" };
      vm.fechitas = [];
      vm.horitas = [];
      vm.options = {
          dateDisabled: disabled,
          startingDay :1,
        customClass: getDayClass,
        //customClass: getColorDays,
        minDate: moment().add('d', 1).toDate(),
        showWeeks: false
      };
      vm.optionsAgenda = {
        dateDisabled: disabled,
        showWeeks:false,
        startingDay :1,
        customClass: getConsultasFechas,
      };
      vm.mostrarCal = false;

      vm.uploadFiles = function (files) {
          if (files && files.length) {
            for (var i = 0; i < files.length; i++) {
              Upload.upload({
                    url: '/ajax/subirdocumentacion',
                    data: { file: files[i] }
                }).then(function (resp) {
                    //console.log(resp);
                    vm.videoconsulta.ficheros.push(resp.data);
                    //vm.videoconsulta.ficheros.push(resp.data.file_name);

                    console.log(vm.videoconsulta.ficheros);
                    //console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
                }, function (resp) {
                    //console.log('Error status: ' + resp.status);
                }, function (evt) {
                    var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                    //console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
                });
            }
            
          }
      }

     vm.errorComplete = function(result){
        $timeout(function(){
          vm.errorB = true;
         console.log("errordd boolean", vm.errorB)
        })

      }

      vm.existeStringFinal = function(time){
        for(var cont=0;cont<vm.stringFinal.length;cont++){
          //console.log("1",vm.stringFinal[cont].fecha);
          //console.log("2",time.fecha);
          if(vm.stringFinal[cont].fecha==time.fecha){
            return cont;
          }
        }
        return false;
      }
      vm.stringFinal = [];
      vm.getStringTimes = function(){
        vm.stringFinal = [];
        //console.log("timesfinal",vm.timesFinal);
        //console.log("length",vm.timesFinal.length);
        for(var cont=0;cont<vm.timesFinal.length;cont++){
          var existe = vm.existeStringFinal(vm.timesFinal[cont]);
          //console.log("existe",existe);
          if(existe===false){
            vm.stringFinal.push({fecha:vm.timesFinal[cont].fecha, horas:[vm.timesFinal[cont].hora]})
          }else{
            vm.stringFinal[existe].horas.push(vm.timesFinal[cont].hora);
          }
        }
        //console.log("stringF",vm.stringFinal);
      }

      vm.orderComplete = function(result){
          PedidoService.finalizarPedidoVideoconsulta(result,vm.stripe).then(function(data){
            vm.pago_realizado = true;
            vm.stripe.loading = false;
         })
      }

      vm.pacienteSeleccionado = function(paciente_id, videoconsulta_id){
          HistorialService.pacienteId(paciente_id,videoconsulta_id).then(function(data){
            vm.paciente = data.paciente;
            vm.videoconsulta = data.videoconsulta;
            vm.videoconsulta.ficheros = (data.videoconsulta.ficheros)?data.videoconsulta.ficheros:[];
            vm.videoconsulta.ficheros = (data.videoconsulta.ficheros)?data.videoconsulta.ficheros:[];
            vm.videoconsulta.paciente_id =data.paciente.id;
            vm.timesFinal = (angular.fromJson(data.videoconsulta.fechas_disponibilidad)) ?
            angular.fromJson(data.videoconsulta.fechas_disponibilidad):[];
            vm.setHorasEscogidas();
            vm.getStringTimes();
          })
      }

      vm.videoconsultaSeleccionada = function(videoconsulta_id){
        vm.loading = true;
        VideoconsultaService.videconsultaId(videoconsulta_id).then(function(data){
            vm.videoconsulta = data.videoconsulta;
            //vm.fechas_saved = (angular.fromJson(data.videoconsulta.fechas_disponibilidad))?
            //angular.fromJson(data.videoconsulta.fechas_disponibilidad):[];
            vm.setHorasEscogidas();
            vm.selected = true;
            $timeout(function(){

              vm.loading = false;
            },200)
              // for (var i = 0; i < vm.fechas_saved.length; i++) {
              //  vm.fechitas = vm.fechas_saved[i].fecha;
              //    console.log("fechas_disponibilidad", vm.fechitas);  
              // }

              // for (var j = 0; j < vm.fechas_saved.length; j++) {
              //     vm.horitas = vm.fechas_saved[j].hora;
              //     console.log("horas_disponibilidad", vm.horitas);
              // }
     
        })
      } 
        vm.selected = false;

      vm.getProducts = function(){
        VideoconsultaService.getProductos(vm).then(function(data){ 
          vm.productos = data.productos;
          vm.numeroPaso = 0;
          vm.comprobarParams();

          //console.log("productos",vm.productos);
            /*vm.especialidad_precio = data.productos[0].precio;
            vm.seguimiento_precio = data.productos[1].precio;
            vm.especialidad_nombre = data.productos[0].nombre;
            vm.seguimiento_nombre = data.productos[1].nombre;*/
           
        })
      }

      vm.getSelected = function(){
        //console.log("Val",vm.selectedProductId);
        //if (vm.selectedProductId == 2531) {
          //SELECCIONAMOS SEGUIMIENTO
          //vm.precio = vm.seguimiento_precio;
          //vm.producto = vm.seguimiento_nombre;
          vm.numeroPaso = vm.numeroPaso +1;
        //}

        if (vm.selectedProductId == 2530 ) {
          //SELECCIONAMOS SEGUIMIENTO SUMAMOS UNO MAS
          vm.numeroPaso = vm.numeroPaso +1;
        }
      
      }
      /*vm.getGo = function(){
        if (vm.numeroPaso == 2) {
          vm.precio = vm.seguimiento_precio;
          vm.producto = vm.seguimiento_nombre;
          vm.selectedProductId = 2531;
        }

        if (vm.numeroPaso == 1) {
          vm.precio = vm.especialidad_precio;
          vm.producto = vm.especialidad_nombre;
          vm.selectedProductId = 2530;
        }
      
      }*/

      vm.modalEditar = "";
      vm.editado = false;
      vm.edit = function(form){
               vm.loading = true;
        VideoconsultaService.SaveCaso(vm).then(function(data){
               vm.loading = false;
            vm.editado = true;
        })
      } 

    function getDayClass(data) {
      //console.log("CUSTOM");
      days = "";
      var fecasSup = "";
      var date = data.date,
      mode = data.mode;
      var days = date.toLocaleDateString();
      vm.days = days;

        if (mode === 'day') {
          var dayToCheck = new Date(date).setHours(0,0,0,0);

          for (var i = 0; i < vm.events.length; i++) {
            var currentDay = new Date(vm.events[i].date).setHours(0,0,0,0);

            if (dayToCheck === currentDay) {
              return vm.events[i].status;
            }
          }
          for (var i = 0; i < vm.timesFinal.length; i++) {
            var explodeFecha = vm.timesFinal[i].fecha.split("/");
            var currentDay = new Date(explodeFecha[2],(parseInt(explodeFecha[1])-1),explodeFecha[0]).setHours(0,0,0,0);
            //console.log("FECHA",vm.timesFinal[i].fecha);
            //console.log("vm.timesFinal[i].fecha",explodeFecha);
            //console.log("currentDay",moment(currentDay).format('DD/MM/YYYY'));
            //console.log("dayToCheck",moment(dayToCheck).format('DD/MM/YYYY'));
            if (dayToCheck === currentDay) {
              //console.log("ACTIVE");
              return 'class_primary';
            }
          }

        }
        return '';
      }

      
      vm.clear = function() {
        vm.dt = null;
      };

      vm.buscarFechaTotales = function(day){
        for(var cont=0;cont<vm.timesFinal.length;cont++){
          if(day==vm.timesFinal[cont].fecha){
            return true;
          }
        }
        /*for(var cont2=0;cont2<vm.fechas_saved.length;cont2++){
          if(day==vm.fechas_saved[cont2].fecha){
            return true;
          }
        }*/
        return false;
      }

      vm.buscarFechaConsulta = function(day,data){
        for (var i = 0; i < vm.videoconsultasCal.length; i++){
          var fecha = new Date(vm.videoconsultasCal[i].fechas);
          var consultaFecha = fecha.toLocaleDateString();                   
            if(day == consultaFecha){
                //console.log("fechas coniciden");
                return 'class_'+vm.videoconsultasCal[i].estado.color_estado;
            
            } 
        }
        return false;
      }

    function getConsultasFechas(data) {
      //console.log(data);
      var date = data.date,
      mode = data.mode;
      var days = date.toLocaleDateString();
      var classRes = false;
      //console.log("FECHA");
        if(classRes = vm.buscarFechaConsulta(days)){
          return classRes;
        }
        return '';
    }


    function getColorDays(data,time) {
      var date = data.date,
      mode = data.mode;
      var days = date.toLocaleDateString();

        if (vm.buscarFechaTotales(days)) {
          //console.log("fechas conicidennnnn");
            return 'especial';
        }
      return '';
    }


    function disabled(data) {
      var date = data.date,
      mode = data.mode;

      return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
    }

    /*vm.toggleMin = function() {
      vm.options.minDate = vm.options.minDate ? null : new Date();
    };
  
     vm.toggleMin();*/
     vm.fechaHoy = new Date();
     vm.getFormatDay = function(fecha){
      return fecha.toLocaleDateString();
     }

      var tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);

      var afterTomorrow = new Date(tomorrow);
        afterTomorrow.setDate(tomorrow.getDate() + 1);
        vm.events = [];/*[
          {
            date: tomorrow,
            status: 'full'
          },
          {
            date: afterTomorrow,
            status: 'partially'
          }
        ];*/

      vm.setHoras = function(){

        var x = 30; //minutes interval
        var times = []; // time array
        var tt = 600; // start time

        for (var i=0;tt<20*60; i++) {
          var hh = Math.floor(tt/60); 

          var mm = (tt%60); // getting minutes of the hour in 0-30 format
          times[i] = ("0" + (hh % 24)).slice(-2) + ':' + ("0" + mm).slice(-2) + [Math.floor(hh/24)]; // pushing data in array in [00:00 - 12:00 AM/PM format]
          tt = tt + x;
          times[i]= times[i].slice(0,5);
        }

        //console.log(times);
        vm.times = times;
      }

      vm.borrarDiaConcreto = function(time,index){
        for(var cont=0;cont<vm.timesFinal.length;cont++){
          if(vm.timesFinal[cont].fecha==time.fecha){
            vm.timesAc[vm.timesFinal[cont].hora] = false
            vm.timesFinal.splice(cont,1);
            cont--;

          }
        }
        console.log("timesAc",vm.timesAc);
        vm.getStringTimes();
      }

      vm.borrarDia = function(time, key){
        vm.timesFinal.splice(key,1);
        if ( vm.currentDay == time.fecha) {
          vm.timesAc[time.hora] = false

        }

        /*vm.fechas_saved.splice(key,1);
        if ( vm.currentDay == time.fecha) {
          vm.timesAc[time.hora] = false

        }*/
        vm.getStringTimes();
        // time.hora
        
      }
      vm.toggleHora = function(valor,time){

        //console.log("currentDayyyyyyyyyy",vm.currentDay);
        console.log("time",time);
        var fechasTiempo = "";
        var key = vm.buscarHora(vm.currentDay,time);
        console.log("key",key);
        if(key!==false){
          vm.timesFinal.splice(key,1);
          //vm.fechas_saved.splice(key,1);
         

        }else{
          vm.timesFinal.push({fecha:vm.currentDay,hora:time});
          //vm.fechas_saved.push({fecha:vm.currentDay,hora:time});        
        }

        console.log("times",vm.timesFinal);
        //console.log("timessaved",vm.fechas_saved);
       
        //console.log("currentDay",vm.currentDay);
        vm.getStringTimes();
        $timeout(function(){
          $('.uib-day .btn.active').click();
        })

      }
      vm.disableds = [];
 
      vm.buscarHora = function(fecha,time){
        for(var cont =0;cont<vm.timesFinal.length;cont++){
          if(vm.timesFinal[cont].fecha==fecha && vm.timesFinal[cont].hora==time){
            return cont;
          }
        }

        /*for(var cont2 =0;cont2<vm.fechas_saved.length;cont2++){
          if(vm.fechas_saved[cont2].fecha==fecha && vm.fechas_saved[cont2].hora==time){ 
            return cont2;
        
          }
        }*/

        return false;
      }

      //chekbox
      vm.setHorasEscogidas = function(){
           // console.log("numerofinal",vm.timesFinal);
           // console.log("fechas saved",vm.fechas_saved);
        for(var cont =0;cont<vm.timesFinal.length;cont++){
          if(vm.timesFinal[cont].fecha==vm.currentDay){
            vm.timesAc[vm.timesFinal[cont].hora] = true;
          }
        }

        /*if (vm.numeroPaso == 8 || vm.numeroPaso == 7) {
         for(var cont2 =0;cont2<vm.fechas_saved.length;cont2++){
            if(vm.fechas_saved[cont2].fecha==vm.currentDay){
              vm.timesAc[vm.fechas_saved[cont2].hora] = true;
            }
          }
        }*/
      }
    
      vm.cambiarDia = function(self){
        //console.log("CAMBIARDIA");
        //reseteamosHoras y variables de horas
        vm.timesAc = {};
        vm.disableds = {};
        vm.setHoras();
        var dateClicked = self.toLocaleDateString();
        if(vm.currentDay!=vm.dt){
          var times = [];
          vm.currentDay = dateClicked;
           console.log("fecha",dateClicked);
              VideoconsultaService.getHorasdisponibles(dateClicked, event).then(function(data){
                for (var i = 0; i < data.length; i++) {
                  for (var j = 0; j < vm.times.length; j++) { 
                    if (vm.times[j] == data[i]) {
                      //vm.times[j] = true;
                        vm.disableds[vm.times[j]] = true;
                        console.log("hora_true",vm.times[j]);
                        console.log("hora",data[i]);
                    }
                  }
                }
                vm.setHorasEscogidas(); 
                
              }

            );
          }
        }

          vm.dateOptions = {
          dateDisabled: disabled,
          formatYear: 'yy',
          showWeeks:false,
          //maxDate: new Date(2020, 5, 22),
          minDate: moment().add('d', 1).toDate(),
          startingDay: 1
        };
         vm.popup1 = {
          opened: false
        };

      vm.open1 = function() {
        vm.popup1.opened = true;
      };
      vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
      vm.format = vm.formats[0];
      vm.altInputFormats = ['M!/d!/yyyy'];

      vm.setDate = function(year, month, day) {
        vm.dt = new Date(year, month, day);
        console.log(vm.dt);
      };

      vm.today = function() {
        vm.dt = new Date();

      };
        vm.today();

      $(document).on("click",".uib-right,.uib-left,.uib-month .btn",function(){
        $('.uib-day .btn.active').click();
        $timeout(function(){
          $('.uib-day .btn.active').click();
        },500)
      })

      vm.getMeses = function(self){
        var dateClicked = self.toLocaleDateString();
        if(vm.currentDay!=dateClicked){
          vm.currentDay = dateClicked;
          //vm.mostrarCal = false;
          //console.log("current",vm.currentDay);
            VideoconsultaService.getMeses(vm).then(function(data){ 
                  vm.videoconsultasCal = data.videoconsultas;
                  //console.log("cal",vm.videoconsultasCal);
                  $timeout(function(){
                    vm.mostrarCal = true;
                  })
            })
          }
      } 

      vm.onChangeMonth = function(self){
        console.log("self",self);
        
      }

     	vm.crearPaciente = function(form){
         if (!form.$valid) {
                angular.element("[name='" + form.$name + "']").find('.ng-invalid:visible:first').focus();
                return false;
          }
          //vm.getGo();
          vm.numeroPaso = vm.numeroPaso + 1;
     	  	VideoconsultaService.SavePaciente(vm).then(function(data){
               vm.pagina = 1; 
               vm.paciente = data.nuevo_paciente;
                console.log("vm.paciente",vm.paciente);
               vm.videoconsulta.paciente_id = data.nuevo_paciente.id;
           })
      } 

      vm.casoClinico = function(form){

          VideoconsultaService.SaveCaso(vm).then(function(data){
            console.log(vm.productoSeleccionado);
               vm.videoconsulta.caso_clinico = "";
               vm.pedido_id = "";
               vm.nueva_video_consulta = data.nueva_video_consulta; 
               vm.sended = false;      
               //vm.stripe.init();
               vm.stripe.setAmount(vm.productoSeleccionado.precio);
               vm.stripe.setDescription(vm.productoSeleccionado.nombre+" ("+vm.generalLab.centro.nombre+")");
               vm.stripe.setProductId(vm.selectedProductId);
               vm.stripe.pedido = data;
               vm.open();
           })
        
      }

      
      // vm.getVideoconsultasByPaciente = function(paciente_id){
      //   VideoconsultaService.getConsultas(paciente_id).then(function(data){ 
      //       vm.videoconsultasList = data.videoconsultas;
      //   })
      // }

      
      vm.getUrlVars = function() {
        var vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
            vars[key] = value;
        });
        return vars;
      }

     

      vm.comprobarParams = function(){
          //var url_string = $window.location.href; 
          //var url = new URL(url_string);
          vm.params = vm.getUrlVars();

          if(vm.params.videoconsulta_id){
            vm.numeroPaso = -1;
              VideoconsultaService.videconsultaId(vm.params.videoconsulta_id).then(function(data){
                  vm.pacienteSeleccionado(data.videoconsulta.paciente_id,data.videoconsulta.id);
                  if(vm.params.paso>0){
                     vm.numeroPaso = parseInt(vm.params.paso);
                  }else{
                    vm.numeroPaso = 7;
                  }
              })
          }
          console.log("params view", vm.params.view_consulta_id);
          if(vm.params.view_consulta_id){
            vm.videoconsultaSeleccionada(vm.params.view_consulta_id);
          }   



          console.log(vm.params);
          if(vm.params.paso<3){
             vm.numeroPaso = parseInt(vm.params.paso);
          }

          if(vm.params.paciente_id){
            vm.pacienteSeleccionado(vm.params.paciente_id);
            vm.numeroPaso = 3;
          }  

          if(vm.params.producto_id){
            vm.selectedProductId = vm.params.producto_id;
            for(var cont=0;cont<vm.productos.length;cont++){
              if(vm.selectedProductId==vm.productos[cont].id){
                vm.productoSeleccionado = vm.productos[cont];
              }
            }
          }
          //console.log("params",vm.params);
      }

      vm.historialconsultas = function(){
        VideoconsultaService.getVideoConsultas(vm).then(function(data){ 
            vm.videoconsultasList = data.videoconsultas;
            //console.log("list",vm.videoconsultasList);

        })
      }
      
      vm.getPacientes = function(){
          HistorialService.getPacientes(vm).then(function(data){ 
              vm.pacientes = data.pacientes;
          })
      }

      vm.getSexos = function(){
          HistorialService.getSexos(vm).then(function(data){ 
                vm.sexos = data.sexos;
          })
      }

      vm.getEstadosvideos = function(){
          VideoconsultaService.getEstados(vm).then(function(data){ 
                vm.estados = data.estados;
          })
      }

      vm.getNotificaciones = function(){
                console.log("entra alertas");
          VideoconsultaService.getAlertas(vm).then(function(data){ 
                vm.alertas = data.alertas;
                console.log(vm.alertas);
          })
      }

      vm.modalInstanceCompra = ""; 
      vm.open = function () {
        console.log("modalvideo");
        vm.modalInstanceCompra = $uibModal.open({
          animation: true,
          ariaLabelledBy: 'modal-title',
          ariaDescribedBy: 'modal-body',
          templateUrl: 'compra',
          backdrop: 'static',
          controller: function($scope, $timeout ){
            $scope.sc = vm;

            $scope.getCupon = function(){
                     
                  PagosService.getCupon($scope).then(function(data){ 
                      if(data.cupon){
                         
                          $scope.cupon = data.cupon; 
                          //$scope.vecesPedidoCupon = data.vecesPedidoCupon; 
                          vm.stripe.cupon = data.cupon; 
                        
                          //console.log($scope.vecesPedidoCupon);
                          //$scope.result = (vm.productoSeleccionado.precio * $scope.cupon.descuento) / 100;
                          $scope.descuento = data.cupon.descuento;
                          vm.stripe.setAmount((vm.productoSeleccionado.precio-((vm.productoSeleccionado.precio*$scope.cupon.descuento)/100)).toFixed(2));
                      }else{
                          $scope.cupon = false; 
                          vm.stripe.setAmount((vm.productoSeleccionado.precio*1).toFixed(2));
                      }
                      $scope.startCupon = true;


                          console.log($scope.cupon.descuento);
                          console.log(vm.productoSeleccionado.precio);
                          console.log("multiplciacion",vm.productoSeleccionado.precio * $scope.cupon.descuento);
                          console.log($scope.result);
                      
                  })
            }

            //$scope.cancel
            $timeout(function() {
               vm.stripe.init()
            }, 10);
            $scope.ko = function(){
              vm.modalInstanceCompra.close();
            }

            $scope.getCupon = function(){
                     
                PagosService.getCupon($scope).then(function(data){ 
                    if(data.cupon){
                       
                        $scope.cupon = data.cupon; 
                        $scope.vecesPedidoCupon = data.vecesPedidoCupon; 
                        vm.stripe.cupon = data.cupon; 
                      
                        console.log($scope.vecesPedidoCupon);
                        //$scope.result = ($scope.prodSelected.precio * $scope.cupon.descuento) / 100;
                        $scope.descuento = data.cupon.descuento;
                        $scope.stripe.setAmount(($scope.prodSelected.precio-(($scope.prodSelected.precio*$scope.cupon.descuento)/100)).toFixed(2));
                    }else{
                        $scope.cupon = false; 
                        $scope.stripe.setAmount(($scope.prodSelected.precio*1).toFixed(2));
                    }
                    $scope.startCupon = true;


                        console.log($scope.cupon.descuento);
                        console.log($scope.prodSelected.precio);
                        console.log("multiplciacion",$scope.prodSelected.precio * $scope.cupon.descuento);
                        console.log($scope.result);
                    
                })
            }
          },
          size: 'lg',

        });

         /*vm.cancel = function () {
            modalInstance.dismiss('cancel');
          };*/
      };   
  }  

})();